module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"make_call":"Call","send_sms":"SMS","send_email":"Send email","Valid":"Valid","Invalid":"Invalid","Risky":"Risky"},"es":{"make_call":"LLamar","send_sms":"SMS","send_email":"Enviar correo","Valid":"Válido","Invalid":"Inválido","Risky":"Riesgoso"}}')
  delete Component.options._Ctor
}
